export default {
  id: 107651,
  person_id: 1,
  commentable_id: 768,
  commentable_type: 'Person',
  body: 'Jason Deppen deactivated Frankie Deppen',
  created_at: '2016-06-24 14:13:52',
}
